import moment from 'moment';

const calculateWaitTime = (seconds) => {
  const waitMiliseconds = seconds * 1000;
  const days = moment.duration(waitMiliseconds).days();
  const waitTime = moment.utc(waitMiliseconds).format('HH:mm:ss');
  return {days, waitTime};
}

export default calculateWaitTime;

